export function getAnchorFromUrl(url: string) {
  if (!url.includes('#')) {
    return '';
  }

  return url.split('#')[1].split('?')[0];
}
